import get from 'lodash/get'
import uniqBy from 'lodash/uniqBy'
import {entitiesApi} from '@/api/entitiesApi'

const types = {
    SET_ENTITIES_LIST: 'SET_ENTITIES_LIST',
    SET_SELECTED_ACCOUNT_ID: 'SET_SELECTED_ACCOUNT_ID',
    SET_WARNING_SOUNDS_LIST: 'SET_WARNING_SOUNDS_LIST',
    SET_ERROR_SOUNDS_LIST: 'SET_ERROR_SOUNDS_LIST',
    SET_ALL_SOUNDS_LIST: 'SET_ALL_SOUNDS_LIST'
};
const state = {
    entitiesList: [],
    selectedAccountID: null,
    warningSounds: [
        { label: 'None', value: 'none', soundId: 1, sound: '' },
        { label: 'Default Warning', value: 'default-warning', soundId: 2, sound: '/sound/default-warning.mp3' }
    ],
    errorSounds: [
        { label: 'None', value: 'none', soundId: 1, sound: '' },
        { label: 'Default Limit', value: 'default-error', soundId: 2, sound: '/sound/default-error.mp3' }
    ],
    allSounds: [
        { label: 'None', value: 'none', soundId: 1, sound: '' }
    ]
};

const mutations = {
    [types.SET_ENTITIES_LIST]: (state, value) => {
        state.entitiesList = value;
    },
    [types.SET_SELECTED_ACCOUNT_ID]: (state, value) => {
        state.selectedAccountID = value
    },
    [types.SET_WARNING_SOUNDS_LIST]: (state, value) => {
        const users = get(state, 'entitiesList.Users', [])
        if (users.length === 0 || !value.UserRecords || value.UserRecords.length === 0) {
            return
        }
        const userRecords = value.UserRecords
            .map(el => {
                el.label = el.Description
                el.sound = el.Rec_Path
                el.value = el.Description
                el.soundId = el.RecordID
                return el
            })
            .sort((a, b) => a.label.localeCompare(b.label))
        state.warningSounds.push(...uniqBy(userRecords, 'label'))
    },
    [types.SET_ERROR_SOUNDS_LIST]: (state, value) => {
        const users = get(state, 'entitiesList.Users', [])
        if (users.length === 0 || !value.UserRecords || value.UserRecords.length === 0) {
            return
        }
        const userRecords = value.UserRecords
            .map(el => {
                el.label = el.Description
                el.src = el.Rec_Path
                el.soundId = el.RecordID
                return el
            })
            .sort((a, b) => a.label.localeCompare(b.label))
        state.errorSounds.push(...uniqBy(userRecords, 'label'))
    },
    [types.SET_ALL_SOUNDS_LIST]: (state, value) => {
        const users = get(state, 'entitiesList.Users', [])
        if (users.length === 0 || !value.UserRecords || value.UserRecords.length === 0) {
            return
        }
        const userRecords = value.UserRecords
            .map(el => {
                el.label = el.Description
                el.src = el.Rec_Path
                el.soundId = el.RecordID
                return el
            })
            .sort((a, b) => a.label.localeCompare(b.label))
        state.allSounds.push(...uniqBy(userRecords, 'label'))
    }
};

const actions = {
    async getEntitiesList ({commit, getters}) {
        let entities = await entitiesApi.getList()
        commit(types.SET_ENTITIES_LIST, entities)
        commit(types.SET_SELECTED_ACCOUNT_ID, get(getters.accountsList, '[0].ID', 1))
        commit(types.SET_WARNING_SOUNDS_LIST, entities)
        commit(types.SET_ERROR_SOUNDS_LIST, entities)
        commit(types.SET_ALL_SOUNDS_LIST, entities)
    }
};

const getters = {
    // getWidgetTemplate: state => templateId => {
    //     return state.allWidgetTemplates.find(t => t.TemplateID.toString() === templateId.toString())
    // }
    getEntityList: state => list => state.entitiesList[list],
    accountsList: state => {
        let accounts = get(state, 'entitiesList.Accounts', [])
        if (accounts.length === 0) {
            accounts.push({
                name: 'Account',
                ID: 1
            })
            return accounts
        }
        return accounts.map(a => {
            return {
                name: a.dist_name,
                ID: a.distributor_id,
                GmtOffset: a.GmtOffset
            }
        })
    },
    usersList: state => {
        const users = get(state, 'entitiesList.Users', [])
        return users.map(user => {
            return {
                name: user.user_name,
                ID: user.user_id
            }
        })
    },
    accountStatuses: state => {
        const accountID = state.selectedAccountID
        const accounts = get(state, 'entitiesList.Accounts', [])
        const account = accounts.find(a => a.distributor_id === accountID)
        if (!account) {
            return []
        }
        return get(account, 'AccountBreaks', [])
    },
    extensionList: state => {
        return get(state, 'entitiesList.Extension', [])
    },
    getExtensionById: (state, getters) => id => {
        return getters.extensionList.find(ext => ext.extension_id === id) || {ext_name: ''}
    },
    getStatusById: (state, getters) => id => {
        return getters.accountStatuses.find(a => a.StatusID.toString() === id.toString()) || {Name: ''}
    },
    getStatusTextById: (state, getters) => id => {
        // Before was: `import statusTypes from "@/enum/statusTypes"; ... getters.getStatusById(id).Name || statusTypes[id].text || 'other'`. Cannot use import of statusTypes because in statusTypes store is imported
        const dynamicStatuses = {
            100: {
                text: 'status.incall',
            },
            101: {
                text: 'status.hold',
            },
            102: {
                text: 'status.atWork',
            }
        }

        return getters.getStatusById(id).Name || dynamicStatuses[id].text || 'other'
    },
    getCurrentAccount: (state, getters) => {
        return getters.accountsList.find(a => a.ID === state.selectedAccountID) || {name: '--'}
    },
    getAccountBreaksLimits: (state, getters) => {
        let breaks = {}
        getters.accountStatuses.forEach(({StatusID, AlertSecLimit, WarningSecLimit}) => {
            breaks[StatusID] = {
                alert: AlertSecLimit,
                warn: WarningSecLimit
            }
        })

        return breaks
    },
    getAccountBreakLimit: (state, getters) => id => {
        return getters.getAccountBreaksLimits[id]
    },
    getWarningSounds (getters) {
        return getters.warningSounds
    },
    getErrorSounds (getters) {
        return getters.errorSounds
    },
    getAllSounds (getters) {
        return getters.allSounds
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
